import type { StateCreator } from 'zustand';

export type WebsiteRecordValue = {
  id: string;
  url: string;
  weight: number;
  kind?: 'page' | 'document';
  selected: boolean;
};

export interface DocumentModalSlice {
  externalDocumentUri: string | undefined;
  setExternalDocumentUri: (externalDocumentUri: string | undefined) => void;
  uri: string;
  setUri: (uri: string) => void;
  webUrls: WebsiteRecordValue[];
  setWebUrls: (urls: WebsiteRecordValue[]) => void;
}

export const documentModalSlice: StateCreator<DocumentModalSlice> = set => ({
  uri: '',
  setUri: uri => set({ uri }),
  externalDocumentUri: undefined,
  setExternalDocumentUri: externalDocumentUri => set({ externalDocumentUri }),
  webUrls: [],
  setWebUrls: urls => set({ webUrls: urls }),
});
